type MetricSort = {
  field: string;
  direction: 'asc' | 'desc';
};

type MetricSortLike = {
  field: unknown;
  direction: unknown;
};

const metricSortFieldMap = new Map<string, string>([
  ['metrics.frequencyPerDay', 'executionFrequencyPerDay'],
  ['metrics.averageDurationMs', 'executionAverageDurationMs'],
  ['metrics.passRate', 'executionPassRate'],
  ['metrics.flakeScore', 'executionFlakeScore'],
  ['metrics.mttfSeconds', 'executionMttfSeconds'],
  ['metrics.delta.frequencyPerDay', 'executionFrequencyPerDayDelta'],
  ['metrics.delta.averageDurationMs', 'executionAverageDurationMsDelta'],
  ['metrics.delta.passRate', 'executionPassRateDelta'],
  ['metrics.delta.flakeScore', 'executionFlakeScoreDelta'],
  ['metrics.delta.mttfSeconds', 'executionMttfSecondsDelta'],
]);

const mapMetricSortField = (field: string): string => metricSortFieldMap.get(field) ?? field;

const isMetricSortLike = (value: unknown): value is MetricSortLike =>
  typeof value === 'object' && value !== null && 'field' in value && 'direction' in value;

export const mapMetricSorts = (sorts: readonly unknown[]): MetricSort[] => {
  const mappedSorts: MetricSort[] = [];
  for (const candidate of sorts) {
    if (!isMetricSortLike(candidate)) {
      continue;
    }
    const field = typeof candidate.field === 'string' ? candidate.field : String(candidate.field);
    const direction = candidate.direction === 'desc' ? 'desc' : 'asc';
    mappedSorts.push({ field: mapMetricSortField(field), direction });
  }
  return mappedSorts;
};
